import {isDevMode, isElectronApp} from "./electron-modules";

interface LinkOptions {
  target?: string;
  name?: string;
}

const engineCloudURLKey = "engineCloudURL";

export const setEngineCloudURL = (url: string, force: boolean = false): boolean => {
  if (!isElectronApp) {
    return false;
  }

  const currentEngineCloudURL = localStorage.getItem(engineCloudURLKey);

  if (currentEngineCloudURL && !force) {
    return false;
  }

  if (currentEngineCloudURL === url) {
    return false;
  }

  localStorage.setItem(engineCloudURLKey, url);
  engineCloudURL = url;

  return true;
};

export let engineCloudURL = (() => {
  if (!isElectronApp) {
    return window.location.origin;
  }

  const engineCloudURL = localStorage.getItem(engineCloudURLKey);

  if (!engineCloudURL) {
    return isDevMode
      ? "http://127.0.0.1:3001"
      : "https://engine.solv3d.com";
  }

  return engineCloudURL;
})();

export const redirectToLogin = () => {
  const searchParams = new URLSearchParams({
    returnTo: window.location.href
  }).toString();

  window.location.href = `/login?${searchParams}`;
};

export const openExternalLink = (href: string, options: LinkOptions = {}) => {
  let element = document.createElement('a');

  element.setAttribute("href", href);

  if (options.target) {
    element.setAttribute("target", options.target);
  } else {
    element.setAttribute("target", "_blank");
  }

  if (options.name) {
    element.setAttribute('download', options.name);
  }

  element.style.display = 'none';
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
};